module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_pp1_9005.5c191ae4.png";